// Unsaved presentations are saved for the presentation's id if editing a presentation
// or the presentation's application id if creating a new presentation.
export default function getUnsavedPresentationId(presentation: {
  id?: string;
  applicationId?: string;
}) {
  return presentation.id || presentation.applicationId || 'new';
}
